import { createSelector } from 'reselect';

import { hasMultiSelectPermission } from '@paragon/login-tools';

import { SelectableItemType } from '../../library/selection/types';

// these items were built with multiselect in mind and are always supported, even without the experimental feature flag
export const ITEMS_ALWAYS_MULTI_SELECTABLE: SelectableItemType[] = [
  'beam',
  'ceilingPlane',
  'ceilingTray',
  'componentDesign',
  'featureArea',
  'featurePatternContainer',
  'member',
  'platePair',
  'roofPlane',
  'trussEnvelope',
  'wall',
  'webSegment',
  'workLine',
];

export const isMultiSelectableItemTypeSelector = createSelector(
  hasMultiSelectPermission,
  (multiSelectPermission) => (type: SelectableItemType) =>
    multiSelectPermission || ITEMS_ALWAYS_MULTI_SELECTABLE.includes(type),
);
